<template>
    <v-form
            v-model="valid"
            ref="recaptchaform"
            lazy-validation
            @submit.prevent="onSubmit"
            @keyup.native.enter="onSubmit"
    >
        <v-card
                :loading="loading"
                :disabled="loading"
        >
            <v-card-title>
                ‘reCAPTCHA’ Settings
            </v-card-title>
            <v-card-text>
                <v-text-field
                        v-model="values.site_key"
                        label="Site key"
                        hint="Enter the key from your Google reCAPTCHA account."
                        persistent-hint
                        :rules="[rules.required]"
                        outlined
                ></v-text-field>
                <v-text-field
                        v-model="values.secret_key"
                        label="Secret key"
                        hint="The secret key is used for communication between your site and Google."
                        persistent-hint
                        :rules="[rules.required]"
                        outlined
                ></v-text-field>
                <v-switch
                        v-model="values.status"
                        :label="values.status ? 'Enabled' : 'Disabled'"
                        color="success"
                        value="1"
                        hide-details
                ></v-switch>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">

                <v-spacer></v-spacer>

                <v-btn
                        color="success"
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                >
                    Save
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
    export default {
        name: 'OptionsRecaptcha',
        data(){
            return {
                loading: false,
                valid: false,
                values: {
                    status: null,
                    site_key: '',
                    secret_key: '',
                },

                rules      : {
                    required: value => !!value || 'Required field.',
                }
            }
        },
        created(){
            this.get();
        },
        methods:{

            get(){
                this.loading = true;

                this.axios.post('options/recaptcha', JSON.stringify( {
                    method: 'show',
                } ) )
                .then((response)=>{

                    const params = response.data;

                    if ( params.status === 'success' ) {

                        this.values    = params.data.values;
                        this.loading = false;
                    } else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                }).catch((reject)=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                });
            },

            onSubmit(){
                if( this.$refs.recaptchaform.validate() ) {
                    this.save();
                }
            },

            save(){

                this.loading = true;

                this.axios.post( 'options/recaptcha', JSON.stringify( {
                    method: 'edit',
                    data: this.values
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.$emit('alert', {type:'success', message: params.message});
                    }else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );

            },
        }
    }
</script>